// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronsUpDown: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
                <path d="M11.974 21.884a1.297 1.297 0 0 1-.919-.375L5.88 16.334a1.3 1.3 0 0 1 1.837-1.837l4.257 4.283 4.27-4.114a1.294 1.294 0 1 1 1.785 1.863l-5.175 4.994a1.293 1.293 0 0 1-.88.361zM12.026 2.116c.344-.002.674.133.919.375l5.175 5.175a1.3 1.3 0 0 1-1.837 1.837L12.026 5.22l-4.27 4.114A1.293 1.293 0 1 1 5.97 7.472l5.175-4.994c.237-.228.552-.358.881-.362z" />
            </g>
        </svg>
    );
};

export const ChevronsUpDownOffset: IconOffset = {
    vertical: 8,
    horizontal: 22,
};

export default React.memo(ChevronsUpDown);
